/**
 * Encode each path segment of a media URL.
 *
 * DriveUrlGenerator already percent-encodes Spatie `original_url` values
 * (`qué` → `%C3%A9` / `que%CC%81`, and `%` in a stored key → `%25`).
 * Re-encoding those segments would turn `%CC%81` into `%25CC%2581` and 403.
 *
 * Only encode segments that are still raw (spaces, unicode, parentheses).
 * Do not use the URL constructor for the path: it decodes %XX first.
 */
export function encodeMediaUrl(url: string | null | undefined): string {
  if (!url) return "";

  const match = url.match(/^(https?:\/\/[^/]+)(\/[^?#]*)(.*)$/i);
  if (!match) return url;

  const [, origin, path, rest] = match;
  const encodedPath = path.split("/").map(encodeMediaPathSegment).join("/");

  return `${origin}${encodedPath}${rest}`;
}

export function encodeMediaUrlsInHtml(html: string | null | undefined): string {
  if (!html) return "";

  return html.replace(/\b(src|href)=(["'])(https?:\/\/[^"']+)\2/gi, (_match, attr: string, quote: string, url: string) => {
    return `${attr}=${quote}${encodeMediaUrl(url)}${quote}`;
  });
}

function encodeMediaPathSegment(segment: string): string {
  if (!segment) return segment;

  // Already percent-encoded (API CDN URL or HTML). Leave it alone.
  if (/%[0-9A-Fa-f]{2}/.test(segment)) {
    return segment;
  }

  return encodeURIComponent(segment);
}
